import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "contentToHide"];

  hideSelf(event) {
    event.target.classList.add("hidden");
  }

  showContent() {
    this.contentTarget.classList.remove("hidden");

    if (this.hasContentToHideTarget) {
      this.contentToHideTarget.classList.add("hidden");
    }
  }

  hideContent() {
    this.contentTarget.classList.add("hidden");
  }

  // Undoes showContent. Bound to turbo:submit-end, it only undoes a failed
  // submission; a successful one is the server's to re-render.
  resetContent(event) {
    if (event?.detail?.success) return;

    this.contentTarget.classList.add("hidden");

    if (this.hasContentToHideTarget) {
      this.contentToHideTarget.classList.remove("hidden");
    }
  }

  toggleContent() {
    this.contentTarget.classList.toggle("hidden");
  }

  togglePressed(event) {
    const button = event.currentTarget;
    button.setAttribute("aria-pressed", button.getAttribute("aria-pressed") !== "true");
  }

  showContentAndScroll() {
    this.showContent();
    this.contentTarget.scrollIntoView({
      behavior: "smooth",
    });
  }
}
